import React from "react";
import { Box } from "@material-ui/core";
import {
  StyledContainer,
  StyledBody,
  StyledAnalytics,
  StyledDate,
  StyledField,
  imageStyles,
  imageBgStyles,
} from "./styles";

const AnalyticBox = ({ data }) => {
  const MainStyledContainer = StyledContainer(data);
  return (
    <MainStyledContainer>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <StyledBody>{data.title}</StyledBody>
        <StyledDate>{data.date}</StyledDate>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <StyledAnalytics>{data.analytics}</StyledAnalytics>
          {!!data?.designation && <StyledField>{data.designation}</StyledField>}
        </Box>
        <img src={data.image} style={imageStyles} />
        <img src={data.bgImage} style={imageBgStyles} />
      </Box>
    </MainStyledContainer>
  );
};

export default AnalyticBox;
